import { $post } from '@/api'
import $msg from '@/utils/message'
import { useRef } from 'react'
import * as qiniu from 'qiniu-js'

interface UploadXlsxOptions {
    complete?: (url: string) => void
    error?: () => void
}

export const useUploadXlsx = (options?: UploadXlsxOptions) => {
    const url = useRef<string>('')

    const observer = useRef({
        next: (res: any) => {},
        error: (err: any) => {
            $msg('error', '上传失败')
            options?.error && options.error()
        },
        complete: (res: any) => {
            url.current = `https://img.senguo.cc/${res.key}`
            options?.complete && options.complete(url.current)
        },
    })

    const upload = (file: any) => {
        $post({
            url: '/goods/getqiniutoken',
            params: { bucket: 1 },
        }).then(data => {
            if (!data?.token) throw new Error('获取上传凭证失败')
            const putExtra = {
                fname: file.name,
            }
            const config: any = {
                useCdnDomain: true,
                region: null,
                checkByMD5: true,
            }
            const observable = qiniu.upload(file, `new_ls/${Date.now()}.xlsx`, data.token, putExtra, config)
            observable.subscribe(observer.current)
        }).catch(error => {
            $msg('error', error.message || '获取上传凭证失败')
            options?.error && options.error()
        })
    }

    return {
        upload,
        url,
    }
}
